var React = require('react');

function LinkOut (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17 13.5v6H5v-12h6m3-3h6v6m0-6-9 9","className":"icon_svg-stroke","stroke":"#5c5c5c","strokeWidth":"1.5","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","transform":"scale(.75)"}));
}

LinkOut.defaultProps = {"width":"24","height":"24","style":{"paddingTop":"4px"}};

module.exports = LinkOut;

LinkOut.default = LinkOut;
